const Divider = ({ children }) => (
	<div className="my-2">
		{children}
	</div>
)

export default Divider